var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-cards-wrapper",attrs:{"id":"cards"}},[_c('event-pois'),_c('cadastre'),_c('rail-images'),_c('sap-card'),_c('explore-card'),_c('event-destination-card'),_c('hunting-regions'),_c('train-location')],1)}
var staticRenderFns = []

export { render, staticRenderFns }